import styled from "styled-components";

const StyledContainer = styled.div`
  background: ${({ token }) => token.page_dashboard__background};
  overflow: auto;
  position: relative;

  &::before {
    content: "";
    background: ${({ token }) => token.page_dashboard__hero_background};
    background-size: cover;
    height: 500px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  .container-content {
    display: flex;
    flex-direction: column;
    gap: 23px;
    margin: 0 auto;
    padding: 41px 0;
    width: 1050px;
  }

  header {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(6px);
    border-radius: 12px;
    box-shadow:
      0 4px 17px 0 rgba(0, 0, 0, 0.04),
      0 4px 4px 0 rgba(0, 0, 0, 0.25),
      0 14px 24px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    gap: 24px;
    padding: 24px;
  }

  .card-action {
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(6px);
    border-radius: 12px;
    box-shadow:
      0 4px 17px 0 rgba(0, 0, 0, 0.04),
      0 4px 4px 0 rgba(0, 0, 0, 0.25),
      0 14px 24px 0 rgba(0, 0, 0, 0.2);
    color: #1e1919;
    display: flex;
    flex: auto;
    justify-content: space-between;
    padding: 24px 0 24px 24px;

    p {
      font-size: 16px;
      font-weight: 300;
      margin: unset;
    }

    h4 {
      font-size: 22px;
      font-weight: 500;
      margin: unset;
    }

    .ant-btn {
      border-color: transparent;
      border-radius: 12px;
      width: 160px;

      &:hover {
        border-color: #0d63cd;
      }
    }

    img {
      height: fit-content;
      width: 108px;
    }
  }

  main {
    backdrop-filter: blur(6px);
    background: rgba(255, 255, 255, 0.93);
    border-radius: 12px;
    box-shadow:
      0 4px 17px 0 rgba(0, 0, 0, 0.04),
      0 4px 4px 0 rgba(0, 0, 0, 0.25),
      0 14px 24px 0 rgba(0, 0, 0, 0.2);
    padding: 32px;

    .ant-tabs .ant-tabs-tab {
      color: #6d6d6d;
    }

    .ant-tabs .ant-tabs-tab-btn {
      font-size: 18px;
    }

    .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: #313131;
    }

    .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
      border-bottom: 4px solid #0d63cd;
    }

    .ant-table-wrapper .ant-table-thead > tr > .cell-accent,
    .ant-table-wrapper .ant-table-tbody > tr > .cell-accent {
      background: #f6f7f8;
    }

    .ant-table-wrapper .ant-table-thead > tr > .cell-accent {
      border-radius: 12px 12px 0 0;
    }
  }
`;

export default StyledContainer;
